import { useAuth } from "@/context/AuthContext";
import api, { apiErr } from "@/lib/api";
import { isSuper } from "@/lib/format";
import { toast } from "sonner";
import { Trash2, Eye } from "lucide-react";

export function SuperDelete({ entity, id, label, onDone, className = "" }) {
  const { user } = useAuth();
  if (!isSuper(user?.role) || user?.impersonated_by) return null;
  const del = async (e) => {
    e.stopPropagation();
    if (!window.confirm(`Delete ${label}? It will go to the Restore Bin (Setup) for 30 days.`)) return;
    try { await api.delete(`/admin/${entity}/${id}`); toast.success(`${label} moved to the Restore Bin`); onDone?.(); }
    catch (err) { toast.error(apiErr(err)); }
  };
  return (
    <button onClick={del} title={`Delete ${label}`} data-testid={`super-delete-${entity}-${id}`}
      className={`inline-flex items-center justify-center h-8 px-2 rounded-md border border-red-500/40 text-red-400 hover:bg-red-500/10 transition-colors ${className}`}>
      <Trash2 className="w-4 h-4" />
    </button>
  );
}

export function ViewAs({ u }) {
  const { user } = useAuth();
  if (!isSuper(user?.role) || user?.impersonated_by || u.id === user.id) return null;
  const go = async () => {
    try { await api.post(`/auth/impersonate/${u.id}`); window.location.href = u.role === "shop_floor" ? "/clock" : "/dashboard"; }
    catch (err) { toast.error(apiErr(err)); }
  };
  return (
    <button onClick={go} title={`View the system as ${u.name}`} data-testid={`view-as-${u.email}`}
      className="inline-flex items-center gap-1 text-xs text-sky-400 hover:underline mr-3"><Eye className="w-3.5 h-3.5" />View as</button>
  );
}
